import Chart from "../assets/Chart.png";

export default function ChartSection() {
  return (
    <div className="card chart-card">
      <h3>YTD Performance </h3>
      <div className="chart-placeholder">
      <img src={Chart}  width="80%"/>
      </div>
    </div>
  );
}